import React, { useState, useEffect } from 'react';
import * as fcl from '@onflow/fcl';

fcl.config()
    .put('accessNode.api', 'https://access-testnet.onflow.org')
    .put('discovery.wallet', 'https://flow-wallet-testnet.blocto.app/authn');

const Context = React.createContext({});

function Provider(props) {
    const [user, setUser] = useState({});

    const logIn = () => {
        fcl.authenticate();
    };
    const logOut = () => {
        fcl.unauthenticate();
    };

    const authentication = async () => {
        if (user && user.addr) {
            fcl.unauthenticate();
        } else {
            fcl.authenticate();
        }
    }

    useEffect(() => {
        fcl.currentUser().subscribe(setUser);
    }, []);

    return (
        <Context.Provider
            value={{
                logIn,
                logOut,
                user,
                authentication
            }}
        >
            {props.children}
        </Context.Provider>
    );
}

export {
    Context as default,
    Provider
};